module.exports = __webpack_public_path__ + "img/leads.70ef6577.svg";